import { render, staticRenderFns } from "./MspTabellaRecords.vue?vue&type=template&id=0c7cd387"
import script from "./MspTabellaRecords.vue?vue&type=script&lang=js"
export * from "./MspTabellaRecords.vue?vue&type=script&lang=js"
import style0 from "./MspTabellaRecords.vue?vue&type=style&index=0&id=0c7cd387&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports